@for (item of items; track item.id || $index) {
  <div class="container-overview d-flex align-items-center py-2">
    <div class="container-overview__icon mx-2">
      <div class="container-overview__icon__wrapper">
        <fa-icon
          class="d-flex align-items-center justify-content-center"
          [icon]="item.icon" />
      </div>
    </div>
    <div class="me-2 flex-grow-1">
      <div class="container-overview__title text-300-medium">{{ item.title }}</div>
      <div
        class="container-overview__description text-100-regular"
        [innerHTML]="item.description"></div>
    </div>
  </div>
}
